import React from 'react';

import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { ApolloProvider } from '@apollo/client/react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { apolloClient } from './graphql/client';
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";

import DashboardView from "./views/Dashboard";
import ErrorBoundary from './components/ErrorBoundary';
import AboutView from './views/About';
import LaunchPage from './views/LaunchPage';
import PrivacyView from './views/Privacy';

import { baseURL } from './utils/urls';

import "./utils/fonts/Montserrat.ttf";
import "./utils/fonts/PTSerif.ttf";
import RolesView from './views/Roles';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        const message = error instanceof Error ? error.message : "";
        if (message === "Unauthorized" || message === "jwt expired") return false;
        return failureCount < 3;
      },
      queryFn: async ({ queryKey }) => {
        const token = localStorage.getItem("jwtToken");
        const headers: { ['Content-Type']: string, Authorization?: string } = {
          'Content-Type': 'application/json'
        };

        if (token) headers.Authorization = `Bearer ${token}`;

        const res = await fetch(`${baseURL}/${queryKey[0]}${queryKey[1] ? `/${queryKey[1]}` : ""}`, {
          headers,
        });
        const data = await res.json().catch(() => null);

        if (data?.message === "jwt expired" || data?.message === "Unauthorized") {
          localStorage.removeItem("jwtToken");
          window.dispatchEvent(new Event("venturify-session-rejected"));
        }

        if (!res.ok) {
          throw new Error(data?.message || "Request failed");
        }

        return data;
      },
    },
  },
});

const router = createBrowserRouter([
  {
    path: "/",
    element: <DashboardView />,
  },
  {
    path: "/about",
    element: <AboutView />,
  },
  {
    path: "/privacy",
    element: <PrivacyView />,
  },
  {
    path: "/:companyId/roles",
    element: <RolesView />,
  },
  {
    path: "/:companySlug",
    element: <LaunchPage />,
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <ErrorBoundary>
    <React.StrictMode>
      <ApolloProvider client={apolloClient}>
      <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      </QueryClientProvider>
      </ApolloProvider>
    </React.StrictMode>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
